export default function locations(state = null) {
    return state;
}
